// extracted by mini-css-extract-plugin
export default {"newproject_container":"NewProject_newproject_container__FTPVJ","new":"NewProject_new__fWU1S"};